/*
 * @Author: edvardchen
 * @Date:   2016-10-23 11:58:55
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-11-17 21:48:22
 */

export default function number2percent(number) {
  if (typeof number !== 'number') {
    return number;
  }
  return `${number * 100}%`;
}
